enum EmailConfirmationStatus {
  Confirmed = "confirmed",
  Pending = "pending",
  Unconfirmed = "unconfirmed",
}

export { EmailConfirmationStatus };
